<section>
  <kendo-gridlayout [rows]="['auto']" [gap]="{rows: 5, cols: 16}" [cols]="['repeat(4,minmax(0,1fr))']">
    <kendo-gridlayout-item [colSpan]="3">
      <app-calendar-user-filter (selectionChanged)="setUserFilters($event)" (enteredPressed)="appliedFilters()"
        [selectedId]="selectedUserIds">
      </app-calendar-user-filter>
    </kendo-gridlayout-item>
    <kendo-gridlayout-item class="filter-actions"
      style="display: flex; align-items: center; gap: 16px; margin-top: 16px;">
      <div class="applied-filter">
        <kendo-button kendoButton themeColor="primary" fillMode="solid" size="medium" (click)="appliedFilters()"
          [disabled]="totalSelectedCount > MAX_INVESTIGATORS">Apply Filters</kendo-button>
      </div>
      <div class="clear-filter">
        <kendo-button kendoButton themeColor="primary" fillMode="link" size="medium" (click)="clearAll()">Clear
          All</kendo-button>
      </div>
    </kendo-gridlayout-item>
    <kendo-gridlayout-item colSpan="2">
      <app-calendar-user-distance-filter (selectionChanged)="setDistanceUserFilters($event)"
        (selectionWithMetricsChanged)="onDistanceSelectionChange($event)" [selectedId]="selectedDistanceUserIds">
      </app-calendar-user-distance-filter>
    </kendo-gridlayout-item>
  </kendo-gridlayout>
</section>
